import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'con-loader',
  templateUrl: './loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class LoaderComponent {
  @Input() showCircularLoder = true;
  @Input() isSmallLoader = false;
}
